const monthNames = ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"];
const monthNamesAbbr = ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"];
//const dayNames = ["Mandag", "Tirsdag", "Onsdag", "Fredag", "Lørdag", "Søndag"];
const dayNamesAbbr = ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"];

export const getMonthName = (date, abbr = false) => {
    if(Object.prototype.toString.call(date) === '[object Date]')
    {
        if(abbr) return monthNamesAbbr[date.getMonth()];
        else return monthNames[date.getMonth()];
    }
    else
    {
        const today = new Date(); 
        if(abbr) return monthNamesAbbr[today.getMonth()];
        return monthNames[today.getMonth()];
    }
}

export const formatDate = (date) => {
    if(Object.prototype.toString.call(date) !== '[object Date]') date = new Date(date);
    if(!date) return "NaN";

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
}

export const formatDateWithMonthAbbr = (date) => {
    if(Object.prototype.toString.call(date) !== '[object Date]') date = new Date(date);
    if(!date) return "NaN";

    const day = String(date.getDate()).padStart(2, '0');
    const month = monthNamesAbbr[date.getMonth()];//String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}. ${month} ${year}`;
}

export const getISOWeek = (date) => {
    if(Object.prototype.toString.call(date) !== '[object Date]') date = new Date(date);
    if(!date) return "NaN";

    const temp = new Date(date.getTime());
    temp.setHours(0, 0, 0, 0);

    temp.setDate(temp.getDate() + 3 - ((temp.getDay() + 6) % 7));

    const week = new Date(temp.getFullYear(), 0, 4);
    return 1 + Math.round(((temp - week) / 86400000 - 3 + ((week.getDay() + 6) % 7)) / 7);
}

export const getMonthGrid = ({ year, month }) => {
    let firstDayOfMonth = new Date(year, month, 1);

    let firstDateOfFirstWeek = new Date(firstDayOfMonth);
    let firstDayOfFirstWeek = firstDateOfFirstWeek.getDay();
    let differenceFirstWeek = (firstDayOfFirstWeek === 0 ? -6 : 1 - firstDayOfFirstWeek);
    firstDateOfFirstWeek.setDate(firstDateOfFirstWeek.getDate() + differenceFirstWeek);

    let lastDayOfMonth = new Date(year, month + 1, 0);

    let lastDateOfLastWeek = new Date(lastDayOfMonth);
    let lastDayOfLastWeek = lastDateOfLastWeek.getDay();
    let differenceLastWeek = (lastDayOfLastWeek === 0 ? 0 : 7 - lastDayOfLastWeek);
    lastDateOfLastWeek.setDate(lastDateOfLastWeek.getDate() + differenceLastWeek);

    let days = [];
    let day = new Date(firstDateOfFirstWeek);

    while (day <= lastDateOfLastWeek) {
        days.push({
            date: new Date(day),
            isInMonth: day.getMonth() === month,
            isWeekend: day.getDay() === 6 || day.getDay() === 0
        });
        day.setDate(day.getDate() + 1);
    }
    
    let weeks = [];
    for (let i = 0; i < days.length; i += 7) {
        weeks.push(days.slice(i, i + 7));
    }

    return weeks;
};

export const parseDuration = (duration) => {
    const totalMinutes = Math.floor(duration * 60);
    const workdaysMinutes = 7.5 * 60;

    const days = Math.floor(totalMinutes / workdaysMinutes);
    const remainingMinutesAfterDays = totalMinutes % workdaysMinutes;

    const hrs = Math.floor(remainingMinutesAfterDays / 60);
    const mins = remainingMinutesAfterDays % 60;

    const pad = (n) => String(n).padStart(2, '0');

    if(days === 0 && hrs === 0) return `${pad(mins)}m.`;
    else if(days === 0 && hrs !== 0) return `${pad(hrs)}t. ${pad(mins)}m.`;
    else return `${pad(days)}d. ${pad(hrs)}t. ${pad(mins)}m.`;
}

export const formatLocalDate = (date, ISOFormat = true) => {
    const offset = date.getTimezoneOffset();
    const local = new Date(date.getTime() - offset * 60000);

    return local.toISOString().slice(0, 10);
    
};

export const getTimelineDates = () => {

    const dates = [];

    const firstDay = new Date();
    const lastDay = new Date();

    firstDay.setDate(firstDay.getDate() - 30);
    lastDay.setDate(lastDay.getDate() + 60);

    for (let d = new Date(firstDay); d <= lastDay; d.setDate(d.getDate() + 1))
    {
        const current = new Date(d);
        dates.push({
            fullDate: formatLocalDate(current),
            date: current.getDate(),
            day: dayNamesAbbr[current.getDay()],
            month: monthNamesAbbr[current.getMonth()],
        })
    }

    return dates;
}

export const parseDateToTimestamp = (date) => {
    const now = new Date();
    const diffMs = date - now;

    const isFuture = diffMs > 0;

    const absMs = Math.abs(diffMs);

    const seconds = Math.floor(absMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (isFuture) {
        if (minutes < 5) return "Nå";
        if (minutes < 60) return `Om ${minutes} min.`;
        if (hours < 24) return `Om ${hours} timer`;
        if (days <= 7) return days === 1 ? "Imorgen" : `Om ${days} dager`;

        const day = String(date.getDate()).padStart(2, "0");
        const month = monthNamesAbbr[date.getMonth()];
        const year = date.getFullYear();

        return `${day} ${month} ${year}`;
    }

    if (minutes < 5) return "Nå";
    if (minutes < 60) return `${minutes}m. siden`;
    if (hours < 24) return `${hours}t. siden`;
    if (days <= 7) return days === 1 ? "Igår" : `${days} dager siden`;

    const day = String(date.getDate()).padStart(2, "0");
    const month = monthNamesAbbr[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};

export const parseDeadline = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    date.setHours(0, 0, 0, 0);

     const diffMs = date - today;
    const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));

    if(diffDays === 0) return "Idag";
    else if(diffDays === 1) return "Imorgen";
    else if(diffDays > 1 && diffDays < 7) return `Om ${diffDays} dager`;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
}